import { reportMemoryExceedsThreshold } from 'analytics/reporters';
import { useCore } from 'contexts/core';
import { useInsights } from 'contexts/insights';

const useMemoryMonitoring = () => {
  const coreApi = useCore();
  const insights = useInsights();
  const performance = window.performance as any;

  const onChange = () => {
    const sessionId = insights.getIds()?.sessionId ?? 'unknown';
    const eventSent = sessionStorage.getItem('memoryEventSent');

    const memory = performance.memory;
    if (!memory || eventSent === sessionId) {
      return;
    }
    const heapSizeLimit = memory.jsHeapSizeLimit;
    const totalHeapSize = memory.totalJSHeapSize;
    if (heapSizeLimit && totalHeapSize && totalHeapSize >= 0.95 * heapSizeLimit) {
      reportMemoryExceedsThreshold({ heapSizeLimit, totalHeapSize });
      sessionStorage.setItem('memoryEventSent', sessionId);
    }
  };

  const unsubscribers = [
    coreApi.subscribe('history', onChange),
    coreApi.subscribe('update', onChange)
  ];

  return () => {
    unsubscribers.forEach(unsubscribe => {
      unsubscribe();
    });
  };
};

export default useMemoryMonitoring;
